import { render } from "./SupportFaq.vue?vue&type=template&id=02a6dc70"
import script from "./SupportFaq.vue?vue&type=script&lang=js"
export * from "./SupportFaq.vue?vue&type=script&lang=js"

import "./SupportFaq.vue?vue&type=style&index=0&id=02a6dc70&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__